import Repository from '../Repository';

export default {

	getAllQualifications() {
		var response = Repository.get('Qualification/GetAllQualifications', {});
		return response;
	}

}
